import { has } from 'lodash';

const initialState = {
  errorMessage: '',
  page: 1,
  data: [],
  uploadError: '',
  fileLoading: false,
  dialogActive: false,
  hasNextPage: true,
  uploadName: '',
  totalCount: 0,
};


const createUploadWithNamedType = (uploadName = '') =>
  (state = initialState, { type, payload }) => {
    const payloadType = has(payload, 'type') ? payload.type : '';
    if (payloadType !== uploadName) return state;

    switch (type) {
      case 'UPLOADS_LIST_REQUEST':
        return {
          ...state,
          listLoading: true,
        };
      case 'UPLOADS_LIST_REQUEST_SUCCESS':
        return {
          ...state,
          listLoading: false,
          data: payload.data[payloadType] || [],
          page: payload.page || state.page,
          hasNextPage: payload.data.has_next_page,
          totalCount: payload.data.total_count,
        };
      case 'UPLOADS_LIST_REQUEST_FAILURE':
        return {
          ...state,
          listLoading: false,
          errors: payload.errors,
        };
      case 'UPLOADS_FILE_UPLOAD':
        return {
          ...state,
          fileLoading: true,
          uploadMessage: '',
          uploadError: {},
        };
      case 'UPLOADS_FILE_UPLOAD_SUCCESS':
        return {
          ...state,
          fileLoading: false,
          uploadMessage: 'Success',
          dialogActive: false,
        };
      case 'UPLOADS_FILE_UPLOAD_FAILURE':
        return {
          ...state,
          fileLoading: false,
          uploadError: payload.errors,
        };
      case 'UPLOAD_DIALOG_TOGGLE':
        return {
          ...state,
          uploadError: '',
          dialogActive: payload.status,
        };
      default:
        return state;
    }
  };

export default createUploadWithNamedType;

const getListData = state => state.data;
const getErrorMessage = state => state.errorMessage;
const getUploadError = state => state.uploadError;
const getFileLoading = state => state.fileLoading;
const getDialogActive = state => state.dialogActive;
const getHasNextPage = state => state.hasNextPage;
const getListLoading = state => state.listLoading;
const getPage = state => state.page;
const getTotalCount = state => state.totalCount;

const getUploadIsProcessing = state => state.data.filter(el => el.status === 'pending').length > 0;

export {
  getListData,
  getErrorMessage,
  getUploadError,
  getFileLoading,
  getDialogActive,
  getListLoading,
  getHasNextPage,
  getUploadIsProcessing,
  getPage,
  getTotalCount,
};



// WEBPACK FOOTER //
// ./client/app/reducers/uploads.js